import React from 'react';
import { DialogComponent } from '../../../../Components';
import { showError, showSuccess } from '../../../../Helper';
import { DeleteTaskConfiguration } from '../../../../Services';
import { useTranslation } from 'react-i18next';

export const DeleteConfigDialog = ({
  onCancelClicked,
  onCloseClicked,
  reloadData,
  isDeleteDialogOpen,
  setIsDeleteDialogOpen,
  translationPath,
  parentTranslationPath,
  activeItem,
}) => {
  const { t } = useTranslation(parentTranslationPath);

  const deleteHandler = async () => {
    const taskConfigId  = activeItem?.taskConfigurationId;
    const res = await DeleteTaskConfiguration(taskConfigId);
    if (!(res && res.status && res.status !== 200)) {
      reloadData();
      showSuccess(t(`${translationPath}config-deleted-successfully2`));
    } else showError(t(`${translationPath}config-delete-failed`));
    setIsDeleteDialogOpen(false);
  };

  return (
    <DialogComponent
      titleText='confirm-message'
      saveText='confirm'
      saveType='button'
      maxWidth='sm'
      dialogContent={
        <div className='d-flex-column-center'>
          <span className='mdi mdi-close-octagon c-danger mdi-48px' />
          <span>{`${t(`${translationPath}config-delete-description`)} "${activeItem?.name}"?`}</span>
        </div>
      }
      saveClasses='btns theme-solid bg-danger w-100 mx-2 mb-2'
      isOpen={isDeleteDialogOpen}
      onCancelClicked={onCancelClicked}
      onCloseClicked={onCloseClicked}
      onSaveClicked={deleteHandler}
      parentTranslationPath={parentTranslationPath}
      translationPath={translationPath}
    />
  );
};
